import { Link } from "react-router";
import { btnPrimaryStyle } from "@components/Button/components/Variant/ButtonPrimary";
import { btnSecondaryStyle } from "@components/Button/components/Variant/ButtonSecondary";
import { ButtonFactoryProps, ButtonType } from "@components/Button/utils/types";
import { cn } from "@util/helpers";

export const btnLinkStyle = cn(
  "font-poppins !text-gray-850 text-base font-semibold leading-150 hover:text-gray-850 hover:underline hover:underline-offset-4 flex tracking-2"
);

/** This is a link that acts like a button. It can have image, text or onClick event. */
const ButtonLink = ({
  className,
  text,
  link,
  onClick,
  mask,
  children,
  icon,
  iconPosition,
  target = "_blank",
}: ButtonFactoryProps): React.ReactElement => {
  if (typeof link === "undefined") return <></>;

  return (
    <Link
      className={cn(
        btnLinkStyle,
        { [btnPrimaryStyle]: mask === ButtonType.Primary },
        { [btnSecondaryStyle]: mask === ButtonType.Secondary },
        className
      )}
      to={link}
      rel="noreferrer"
      referrerPolicy="strict-origin-when-cross-origin"
      data-testid="button-link-component"
      onClick={onClick}
      target={target}
      reloadDocument
    >
      {children ? (
        children
      ) : (
        <>
          {iconPosition === "left" && icon ? icon : null}
          {text ? text : null}
          {iconPosition === "right" && icon ? icon : null}
        </>
      )}
    </Link>
  );
};

export default ButtonLink;
